import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ArtDirection extends UcoastEl {
	static htmlSelector = 'art-direction'
	isDeferred: boolean
	isPriority: boolean
	constructor() {
		super()
		this.isDeferred = this.hasAttribute('data-defer')
		this.isPriority = this.checkIsPriority()
		if (this.isDeferred) {
			window.setTimeout(() => {
				this.releaseDeferredStatus()
			}, 10000)
		}
		if (this.isPriority) {
			this.forceLoadPriorityImages()
		}
	}

	override async connectedCallback() {
		super.connectedCallback()
	}
	onMediaLoad() {
		this.classList.add('loaded')
	}
	getPriorityImages() {
		return Array.from(
			q.ol<HTMLImageElement>('img[fetchpriority="high"]', this) ?? []
		).filter((img) => !this.isHiddenForViewport(img))
	}
	forceLoadPriorityImages() {
		this.getPriorityImages().forEach((img) => {
			void this.forceLoadImage(img)
		})
	}
	releaseDeferredStatus() {
		if (!this.isDeferred) return
		const deferredImages = q.ol<HTMLImageElement | HTMLSourceElement>(
			'img[data-src], img[data-srcset], source[data-srcset], source[data-src]',
			this
		)
		deferredImages?.forEach((image) => {
			const src = q.oa(image, 'data-src')
			const srcset = q.oa(image, 'data-srcset')
			if (srcset) {
				image.srcset = srcset
				image.removeAttribute('data-srcset')
			}
			if (src) {
				image.src = src
				image.removeAttribute('data-src')
			}
		})
		this.isDeferred = false
		this.removeAttribute('data-defer')
	}
	checkIsPriority() {
		const priorityImages = this.getPriorityImages()
		return priorityImages.length > 0
	}
	isHiddenForViewport(img: HTMLImageElement) {
		return (
			img.getBoundingClientRect().height < 1 ||
			img.getBoundingClientRect().width < 1
		)
	}
	async forceLoadImage(imgElement: HTMLImageElement) {
		// Create a new image element
		const img = new Image()

		// Copy attributes from the original element
		img.src = imgElement.src
		img.alt = imgElement.alt
		img.srcset = imgElement.srcset
		img.sizes = imgElement.sizes
		img.className = imgElement.className
		img.fetchPriority = 'high'
		img.loading = 'eager'

		try {
			if (img.decode) {
				await img.decode()
			}
		} catch (error) {
			console.error('Image decoding failed, but continuing:', error)
		}

		// Replace the original image with the new one
		//imgElement.parentNode.replaceChild(img, imgElement);
		window.Ucoast.mediaManager.markPriorityImageLoaded(this)

		return img
	}
}
